import { museumApiBaseUrl, museumApiPassword, museumApiUsername } from '~/constants/museum'
import { Benefits, UpdateBenefitsRequest } from '~/domain/Benefits'

export const getBenefits = async (trophyId: string): Promise<Benefits> => {
  const method = 'GET'
  const path = `${museumApiBaseUrl}/trophies/${trophyId}/benefits`
  const response = await fetch(path, { method })

  if (!response.ok) throw new Error(`Cannot get benefits: ${response.status}`)

  return await response.json()
}

export const updateBenefits = async (
  trophyId: string,
  request: UpdateBenefitsRequest
): Promise<void> => {
  const method = 'PUT'
  const path = `${museumApiBaseUrl}/trophies/${trophyId}/benefits`
  const body = JSON.stringify(request.benefits)
  const credentials = Buffer.from(`${museumApiUsername}:${museumApiPassword}`).toString('base64')
  const headers = {
    'content-type': 'application/json; charset=UTF-8',
    'authorization': `Basic ${credentials}`,
  }

  const response = await fetch(path, { method, headers, body })

  if (!response.ok) throw new Error(`Cannot update benefits: ${response.status}`)
}
